import React from 'react';

const SavedBanner = () => (
  <div className="banner banner__green">
    Content Has Been Saved
  </div>
);

export default SavedBanner;


// WEBPACK FOOTER //
// ./src/components/utilities/SavedBanner.js